var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { SymbolSvgLogoManager } from '@shared/commons/UtilsClasses/SymbolSvgLogoManager';
import { Resources } from '@shared/localizations/Resources';
import { AlertSubImage, AlertSymbolConditionMap, AlertType, AlertTypeMap } from '@shared/utils/Alert/AlertConstants';
import AlertItemSideBarTemplate from '@front/templates/AlertItemSideBarTemplate.html';
import { ControlsTypes } from '../../../UtilsClasses/FactoryConstants';
import { Control } from '../../Control';
export class AlertItemSideBar extends Control {
    constructor() {
        super(...arguments);
        this.Alert = null;
    }
    oncomplete() {
        super.oncomplete();
        this.on('onItemClick', this.onItemClick);
        this.observe('alert', this.updateAlertData);
    }
    setDataAlert() {
        const alert = this.get('alert');
        this.Alert = alert;
        if (isNullOrUndefined(alert)) {
            return;
        }
        const instrument = alert.Instrument;
        const symbolName = instrument.DisplayName();
        const symbolDescription = instrument.DescriptionValue();
        const conditionText = this.getConditionValue(alert, instrument);
        this.setActiveState(alert);
        void this.set({ symbolName, symbolDescription, conditionText });
    }
    updateAlertData(newValue, oldValue) {
        if (!oldValue || newValue.AlertId !== oldValue.AlertId) {
            this.setDefaultLogo(newValue.Instrument);
            void this.getImg(newValue.Instrument);
        }
        this.setDataAlert();
    }
    getType() {
        return ControlsTypes.AlertItemSideBar;
    }
    setActiveState(alert) {
        const activeAlert = alert.Active;
        let activeText = '';
        if (activeAlert) {
            activeText = Resources.getResource('screen.Alerts.item.active');
        }
        else {
            activeText = Resources.getResource('screen.Alerts.item.stopped');
        }
        void this.set({ activeAlert, activeText });
    }
    getConditionValue(alert, instrument) {
        let formattedValue = '';
        if (alert.AlertType === AlertType.CHANGE) {
            formattedValue = alert.Value.toFixed(2);
        }
        else if (alert.AlertType === AlertType.VOLUME) {
            formattedValue = alert.Value.toString();
        }
        else {
            formattedValue = instrument.formatPrice(alert.Value);
        }
        const comment = alert.MessageText;
        const alertTypeText = Resources.getResource('panel.watchlist.' + AlertTypeMap[alert.AlertType]);
        const alertSymbolCondition = AlertSymbolConditionMap[alert.Condition];
        let value = `${alertTypeText} ${alertSymbolCondition} ${formattedValue}`;
        if (isValidString(comment)) {
            value += ` | ${comment}`;
        }
        return value;
    }
    setDefaultLogo(instrument) {
        const symbolLogoStr = instrument.LogoName();
        const svgLogo = SymbolSvgLogoManager.getDefaultImage(symbolLogoStr);
        void this.set({ svgLogo });
    }
    getImg(instrument) {
        return __awaiter(this, void 0, void 0, function* () {
            const svgImage = yield SymbolSvgLogoManager.LoadSvgImage(instrument.LogoAddress);
            if (svgImage) {
                void this.set('svgLogo', svgImage);
            }
        });
    }
    onActionButtonClick(context, action) {
        this.fire("actionClick" /* AlertEvents.ActionClick */, this, action);
        context.event.stopPropagation();
    }
    onItemClick() {
        this.fire("actionClick" /* AlertEvents.ActionClick */, this, AlertSubImage.UPDATE);
    }
}
Control.extendWith(AlertItemSideBar, {
    template: AlertItemSideBarTemplate,
    data: function () {
        return {
            alert: null,
            symbolName: '',
            symbolDescription: '',
            svgLogo: '',
            conditionText: '',
            activeAlert: false,
            activeText: '',
            playStopAction: AlertSubImage.PLAY_STOP,
            editAction: AlertSubImage.UPDATE,
            closeAction: AlertSubImage.CLOSE
        };
    }
});
